import { Helmet } from 'react-helmet-async'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'


const PrivacyPage = () => {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - DevSecRoot</title>
        <meta name="description" content="DevSecRoot's privacy policy - how we collect, use, and protect your personal information." />
        <link rel="canonical" href="https://devsecroot.com/privacy" />
      </Helmet>

      <section className="pt-32 pb-16">
        <div className="container-max">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-dsr-text mb-6">
              Privacy Policy
            </h1>
            <p className="text-xl text-dsr-text/70 max-w-2xl mx-auto">
              How we collect, use, and protect your personal information
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="glass-card-hover p-8 max-w-4xl mx-auto"
          >
            <div className="prose prose-invert max-w-none">
              <p className="text-dsr-text/70 mb-6">
                <strong>Last updated:</strong> {new Date().toLocaleDateString()}
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Information We Collect</h2>
              <p className="text-dsr-text/70 mb-6">
                We collect information you provide directly to us, such as when you contact us, 
                request a quote, or subscribe to our newsletter. This may include your name, 
                email address, company name, and project details.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">How We Use Your Information</h2>
              <p className="text-dsr-text/70 mb-6">
                We use the information we collect to provide our services, communicate with you, 
                improve our offerings, and comply with legal obligations.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Information Sharing</h2>
              <p className="text-dsr-text/70 mb-6">
                We do not sell, trade, or otherwise transfer your personal information to third parties 
                without your consent, except as required by law or to provide our services.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Data Security</h2>
              <p className="text-dsr-text/70 mb-6">
                We implement appropriate security measures to protect your personal information 
                against unauthorized access, alteration, disclosure, or destruction.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Your Rights</h2>
              <p className="text-dsr-text/70 mb-6">
                You have the right to access, update, or delete your personal information. 
                You may also opt out of marketing communications at any time.
              </p>

              <h2 className="text-2xl font-bold text-dsr-text mb-4">Contact Us</h2>
              <p className="text-dsr-text/70 mb-6">
                If you have questions about this privacy policy or our data practices, 
                please contact us at{' '}
                <a href="mailto:privacy@devsecroot.com" className="text-dsr-accent hover:text-cyan-400">
                  privacy@devsecroot.com
                </a>
              </p>

              <div className="mt-8 pt-6 border-t border-white/10">
                <Link to="/contact" className="btn-primary">
                  Contact Us
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  )
}

export default PrivacyPage
